import { Chip } from '@mui/material';
import { FC } from 'react';
import { ReferenceArrayField, SingleFieldList, useRecordContext, useTranslate } from 'react-admin';
import { Hardware } from 'types/Hardware';
import { SoftwareComponent } from 'types/SoftwareComponent';

const HardwareChip: FC<{ requiredHardwareIds: number[] }> = ({ requiredHardwareIds }) => {
  const hardware = useRecordContext<Hardware>();

  if (!hardware) return null;

  const isRequired = requiredHardwareIds.includes(hardware.id);

  return (
    <Chip label={hardware.name} color={isRequired ? 'primary' : 'default'} size="small" sx={{ mr: 0.5, mb: 0.5 }} />
  );
};

const HardwareCompatibilityField: FC<{ label?: string }> = () => {
  const record = useRecordContext<SoftwareComponent>();
  const translate = useTranslate();
  const hardwareIds = record?.hardware_ids || [];
  const requiredHardwareIds = record?.required_hardware_ids || [];

  if (hardwareIds.length === 0) {
    return <Chip label={translate('custom.labels.universal')} size="small" />;
  }

  return (
    <ReferenceArrayField source="hardware_ids" reference="hardware">
      <SingleFieldList linkType={false}>
        <HardwareChip requiredHardwareIds={requiredHardwareIds} />
      </SingleFieldList>
    </ReferenceArrayField>
  );
};

export default HardwareCompatibilityField;
